import { render } from "./ItemRemovePopup.vue?vue&type=template&id=03269a52"
import script from "./ItemRemovePopup.vue?vue&type=script&lang=js"
export * from "./ItemRemovePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__